const OrderState = {
    empty: 1,
    collapsed: 2,
    edit: 3,
    edititem: 4,
    add: 5,
    pay: 6    
};

export default OrderState;